import React, { useState, useEffect, useContext, useRef } from 'react';

import PropTypes from 'prop-types';

import { Link, useNavigate } from 'react-router-dom';

import {
  Stack,
  Button,
  Box,
  MenuItem,
  Typography,
  IconButton,
  Grid,
  CircularProgress,
  Backdrop,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Tooltip,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CommentIcon from '@mui/icons-material/Comment';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import NotesIcon from '@mui/icons-material/Notes';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import LinkTwoToneIcon from '@mui/icons-material/LinkTwoTone';
import { toast } from 'react-hot-toast';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Chip from '@mui/material/Chip';
import MUIDataTable, { TableFilterList } from 'mui-datatables';
import dayjs from 'dayjs';
import { AuthContext } from 'src/context/AuthContext';
import CommentsModal from 'src/components/SharedComponent/Scheduling/comment_modal';
import AssignUserModel from 'src/components/SharedComponent/Scheduling/assign_user_modal';
import NewScheduleModal from 'src/components/SharedComponent/Scheduling/new_schedule_modal';
import {
  LinkedDwrModal,
  getLinkedDwrs,
  getVisibleLinkedDwrs,
} from './linked_dwr';

import { getScheduleColor } from 'src/utils/scheduleColorUtils';
import ColorLegend from 'src/components/SharedComponent/Scheduling/ColorLegend';
import TodoDraftUpdateModal from './tododraft_UpdateModal';
import MessageDialog from './AlertDialog';
import ViewToDoDraftModal from 'src/components/SharedComponent/Scheduling/ViewToDoDraftModal';
import ScheduleIcon from '@mui/icons-material/Schedule';
import RefreshIcon from '@mui/icons-material/Refresh';

const { PRIVATE_ROUTE } = API_ROUTES;

export default function ListView() {
  const { state } = useContext(AuthContext);
  const isAdmin = ['admin', 'administrator'].includes(
    String(state.user?.role || '').toLowerCase()
  );
  const { authAxios } = useContext(FetchContext);

  const columnVisibilityKey = state.user?._id
    ? `ListViewColumnVisibility_${state.user._id}`
    : null;

  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(null);

  const [sortEnable, setSortEnable] = useState({
    sortField: 'updatedAt',
    sortOrder: 'desc',
  });

  const [searchEnable, setSearchEnable] = useState();
  const [filterManagerdata, setFilterManagerdata] = useState([]);
  const [manageId, setManageId] = useState('All_Manager');
  const [selectedPlannedDate, setSelectedPlannedDate] = useState(null);
  const [selectedGroupNumber, setSelectedGroupNumber] = useState('');
  const [isValid, setIsValid] = useState(false);

  const [openUserModal, setUserModal] = useState(false);
  const [openCommentModal, setCommentModal] = useState(false);
  const [openNewScheduleModal, setOpenNewScheduleModal] = useState(false);

  const [selectedSchedule, setSelectedSchedule] = useState(null);

  const [rawSchedules, setRawSchedules] = useState([]);
  const [allSchedulesForAssign, setAllSchedulesForAssign] = useState([]);

  const [openDescriptionModal, setDescriptionModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState('');

  const [validCostItems, setValidCostItems] = useState([]);
  const [unassignTarget, setUnassignTarget] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [todoDraftUpdateModal, setTodoDraftUpdateModal] = useState(false);

  const [scheduleModalData, setScheduleModalData] = useState([]);
  const [scheduleLoading, setScheduleLoading] = useState(false);

  const [openViewToDoDraftModal, setOpenViewToDoDraftModal] =
    useState(false);

  const [duplicateAssignTarget, setDuplicateAssignTarget] = useState(null);
  const [duplicateLoading, setDuplicateLoading] = useState(false);


  /*
   * ============================================================
   * DWR MODAL STATE
   * ============================================================
   */
  const [openDwrModal, setOpenDwrModal] = useState(false);
  const [selectedDwrSchedule, setSelectedDwrSchedule] =
    useState(null);
  const [dwrModalData, setDwrModalData] = useState([]);
  const [dwrModalLoading, setDwrModalLoading] = useState(false);

  const [scheduleLinkedDwrs, setScheduleLinkedDwrs] = useState({});

  const [messageDialog, setMessageDialog] = useState({
    open: false,
    severity: 'info',
    title: '',
    message: '',
    okText: 'OK',
    cancelText: null,
    onConfirm: null,
  });

  const [todoDraftData] = useState({
    schedule: null,
    fieldTripDate: null,
    description: '',
    status: '',
  });

  const prevUserModalRef = useRef(openUserModal);

  const [columnVisibility, setColumnVisibility] = useState({});

  useEffect(() => {
    if (!columnVisibilityKey) {
      setColumnVisibility({});
      return;
    }

    try {
      const saved = localStorage.getItem(columnVisibilityKey);

      setColumnVisibility(saved ? JSON.parse(saved) : {});
    } catch (error) {
      console.error('Failed to load column visibility:', error);
      setColumnVisibility({});
    }
  }, [columnVisibilityKey]);

  /*
   * ============================================================
   * DWR VIEW HANDLER
   * ============================================================
   */
  /*
 * ============================================================
 * DWR VIEW HANDLER
 * ============================================================
 *
 * DWR modal is schedule-based.
 *
 * IMPORTANT:
 * Do not filter the modal by the logged-in manager/employee.
 * The schedule_id identifies the schedule, and the backend
 * returns all DWRs linked to that schedule.
 *
 * Visible statuses:
 *   0 = Pending
 *   1 = Approved
 *
 * Hidden statuses:
 *   2 = Rejected
 *   3 = Open
 */
  const fetchDwrAvailability = async (schedules) => {
    if (!Array.isArray(schedules) || schedules.length === 0) {
      return;
    }

    const scheduleIds = schedules
      .map((schedule) => schedule?._id)
      .filter(Boolean)
      .map((id) => String(id));

    if (scheduleIds.length === 0) {
      return;
    }

    try {
      const linkedDwrs = await getLinkedDwrs({
        authAxios,
        route: PRIVATE_ROUTE.GET_DWR_AVAILABLE_WORK,
        schedule_ids: scheduleIds,
      });

      const visibleDwrs = getVisibleLinkedDwrs(linkedDwrs);

      const availability = {};

      scheduleIds.forEach((scheduleId) => {
        availability[scheduleId] = visibleDwrs.filter((dwr) => {
          const dwrScheduleId = String(dwr?.schedule_id || '');

          const isTodoDraftDwr = Boolean(
            dwr?.todo_draft_id
          );

          return (
            dwrScheduleId === scheduleId &&
            !isTodoDraftDwr
          );
        });
      });

      setScheduleLinkedDwrs(availability);
    } catch (error) {
      console.error(
        'Error fetching DWR availability:',
        error
      );
    }
  };

  const handleViewDwr = (schedule) => {
    const scheduleId = String(schedule?._id || '');

    const linkedDwrs =
      scheduleLinkedDwrs[scheduleId] || [];

    setSelectedDwrSchedule(schedule);
    setDwrModalData(linkedDwrs);
    setOpenDwrModal(true);
  };

  const columns = [
    {
      name: '_id',
      label: 'Id',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: false,
      },
    },

    {
      name: `job_number`,
      label: 'Job Number',
      options: {
        draggable: true,
        sort: true,
        filter: false,
        display: columnVisibility.job_number ?? true,
      },
    },

    {
      name: 'task_number',
      label: 'Task Number',
      options: {
        draggable: false,
        sort: true,
        filter: false,
        display: columnVisibility.task_number ?? true,
      },
    },

    {
      name: 'client_number',
      label: 'Client',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.client_number ?? true,
      },
    },

    {
      name: 'manager',
      label: 'Project Manager',
      options: {
        draggable: false,
        sort: false,
        filter: true,

        filterOptions: {
          names: [
            ...filterManagerdata.map(
              (manager) =>
                `${manager.first_name} ${manager.last_name}`
            ),
          ],
          fullWidth: true,
        },

        customFilterListRender: (value) => {
          const selectedManager =
            filterManagerdata.find(
              (manager) =>
                `${manager.first_name} ${manager.last_name}` ===
                value
            );

          if (selectedManager) {
            setManageId(selectedManager._id);
          }

          return <div>{value}</div>;
        },

        display: columnVisibility.manager ?? true,
      },
    },

    {
      name: 'city',
      label: 'City',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.city ?? true,
      },
    },

    {
      name: 'task_scope',
      label: 'Task Scope',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.task_scope ?? true,
      },
    },

    {
      name: 'cost_item',
      label: 'Cost Item',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.cost_item ?? true,

        setCellProps: () => ({
          style: {
            width: '200px',
            minWidth: '200px',
            maxWidth: '200px',
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: '200px',
            minWidth: '200px',
            maxWidth: '200px',
          },
        }),
      },
    },

    {
      name: `group_number`,
      label: 'Group Number',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.group_number ?? true,

        setCellProps: () => ({
          style: { textAlign: 'center' },
        }),

        setCellHeaderProps: () => ({
          style: { textAlign: 'center' },
        }),
      },
    },

    {
      name: `seq_number`,
      label: 'Seq Number',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.seq_number ?? true,

        setCellProps: () => ({
          style: { textAlign: 'center' },
        }),

        setCellHeaderProps: () => ({
          style: { textAlign: 'center' },
        }),
      },
    },

    {
      name: 'planned_date',
      label: 'Planned Date',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: columnVisibility.planned_date ?? true,

        customBodyRender: (value, tableMeta) => {
          const scheduleId = tableMeta.rowData?.[0];

          const item = rawSchedules.find(
            (schedule) =>
              String(schedule?._id) ===
              String(scheduleId)
          );

          const linkedDwrs =
            scheduleLinkedDwrs[String(scheduleId)] || [];

          const hasLinkedDwr = linkedDwrs.length > 0;

          const hasLinkedTodoDraft =
            Boolean(item?.hasTodoDraft);

          return (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                minWidth: 110,
              }}
            >
              <span>{value}</span>

              {/* =================================================
              LINKED DWR
              One icon per schedule only
             ================================================= */}
              {hasLinkedDwr && (
                <Tooltip title="View Linked DWR">
                  <IconButton
                    size="small"
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();

                      handleViewDwr(item);
                    }}
                    sx={{
                      color: '#3DADB5',
                      padding: '2px',
                      marginLeft: '2px',

                      '&:hover': {
                        backgroundColor:
                          '#E0F6F8',
                        color: '#2E9DA6',
                      },
                    }}
                  >
                    <AssignmentIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

              {/* =================================================
              LINKED TODO DRAFT
             ================================================= */}
              {hasLinkedTodoDraft && (
                <Tooltip title="View Linked ToDo Draft">
                  <IconButton
                    size="small"
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();

                      handleViewSchedules(item);
                    }}
                    sx={{
                      color: '#3DADB5',
                      padding: '2px',
                      marginLeft: '2px',

                      '&:hover': {
                        backgroundColor:
                          '#E0F6F8',
                      },
                    }}
                  >
                    <ScheduleIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      },
    },

    /*
     * ============================================================
     * ASSIGNED MEMBERS + DWR ICON
     * ============================================================
     */
    {
      name: 'assigned_members',
      label: 'Assigned Members',

      options: {
        draggable: false,
        sort: false,
        filter: false,
        display:
          columnVisibility.assigned_members ?? true,

        customBodyRender: (value, tableMeta) => {
          const scheduleId = tableMeta.rowData?.[0];

          const schedule = rawSchedules.find(
            (item) =>
              String(item?._id) ===
              String(scheduleId)
          );

          const assignedMembers =
            schedule?.assigned_members || [];

          if (!assignedMembers.length) {
            return value || '';
          }

          return (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.4,
              }}
            >
              {assignedMembers.map(
                (employee, index) => {
                  const employeeName =
                    `${employee?.first_name || ''} ${employee?.last_name || ''
                      }`.trim() ||
                    'Unknown Employee';

                  return (
                    <Typography
                      key={
                        employee?._id ||
                        employee?.employee ||
                        index
                      }
                      variant="body2"
                      sx={{
                        fontSize: '0.78rem',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        minWidth: 0,
                      }}
                    >
                      {employeeName}
                    </Typography>
                  );
                }
              )}
            </Box>
          );
        },
      },
    },

    {
      name: 'document_link',
      label: 'Document Link',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display:
          columnVisibility.document_link ?? true,

        setCellProps: () => ({
          style: { textAlign: 'center' },
        }),

        setCellHeaderProps: () => ({
          style: { textAlign: 'center' },
        }),
      },
    },

    {
      name: 'estimated_hours',
      label: 'Estimated Hours',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display:
          columnVisibility.estimated_hours ?? true,

        setCellProps: () => ({
          style: { textAlign: 'center' },
        }),

        setCellHeaderProps: () => ({
          style: { textAlign: 'center' },
        }),
      },
    },

    {
      name: 'comments',
      label: 'Comments',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display:
          columnVisibility.comments ?? true,

        setCellProps: () => ({
          style: { textAlign: 'center' },
        }),

        setCellHeaderProps: () => ({
          style: { textAlign: 'center' },
        }),
      },
    },

    {
      name: 'description',
      label: 'Description',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display:
          columnVisibility.description ?? true,

        setCellProps: () => ({
          style: { textAlign: 'center' },
        }),

        setCellHeaderProps: () => ({
          style: { textAlign: 'center' },
        }),

        customBodyRender: (value) =>
          value ? (
            <Tooltip title="View description">
              <IconButton
                size="small"
                onClick={() => {
                  setSelectedDescription(value);
                  setDescriptionModal(true);
                }}
                sx={{ color: '#3DADB5' }}
              >
                <NotesIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          ) : null,
      },
    },

    {
      name: `active`,
      label: 'Assign Task',
      options: {
        draggable: false,
        filter: false,
        display: columnVisibility.active ?? true,

        setCellProps: () => ({
          style: { textAlign: 'center' },
        }),

        setCellHeaderProps: () => ({
          style: { textAlign: 'center' },
        }),
      },
    },
    {
      name: 'actions',
      label: 'Action',
      options: {
        draggable: false,
        sort: false,
        filter: false,
        display: true,

        setCellProps: () => ({
          style: {
            textAlign: 'center',
            whiteSpace: 'nowrap',
            width: '110px',
            minWidth: '110px',
            padding: '8px',
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '110px',
            minWidth: '110px',
            padding: '8px',
          },
        }),

        customBodyRender: (value, tableMeta) => {
          const scheduleId = tableMeta.rowData?.[0];

          const item = rawSchedules.find(
            (schedule) =>
              String(schedule?._id) === String(scheduleId)
          );

          if (!item) return null;

          return (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                gap: 0,
              }}
            >
              <Tooltip title="Duplicate Schedule">
                <IconButton
                  size="small"
                  onClick={() => handleDuplicateSchedule(item)}
                  disabled={duplicateLoading}
                  sx={{
                    color: '#3DADB5',
                    p: 0.75,
                    '&:hover': {
                      backgroundColor: '#E0F6F8',
                    },
                  }}
                >
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Delete Schedule">
                <IconButton
                  size="small"
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setDeleteTarget(item);
                  }}
                  sx={{
                    color: '#D32F2F',
                    p: 0,
                    '&:hover': {
                      backgroundColor: '#FDECEC',
                    },
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    selectToolbarPlacement: 'none',
    tableId: 'SchedulingListView',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standard',
    print: true,
    filter: false,
    fixedHeader: true,

    onViewColumnsChange: (
      changedColumn,
      action
    ) => {
      setColumnVisibility((prev) => {
        const updated = {
          ...prev,
          [changedColumn]: action === 'add',
        };

        if (columnVisibilityKey) {
          localStorage.setItem(
            columnVisibilityKey,
            JSON.stringify(updated)
          );
        }

        return updated;
      });
    },

    tableBodyHeight:
      'max(200px, calc(100vh - 370px))',

    searchOpen: true,

    count: count,

    selectableRows: 'none',

    page: page ?? 0,

    customToolbar: () => (
      <>
        <Tooltip title="Calendar View">
          <IconButton
            onClick={() =>
              navigate(
                '/scheduling/calander_view'
              )
            }
            sx={{
              color: '#3DADB5',

              '&:hover': {
                backgroundColor: '#E0F6F8',
              },
            }}
          >
            <CalendarMonthIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Refresh">
          <IconButton
            onClick={handleRefresh}
            disabled={loading}
            size="small"
            sx={{
              color: '#65C8D0',

              '&:hover': {
                backgroundColor: '#E0F6F8',
              },
            }}
          >
            <RefreshIcon
              sx={{
                animation: loading
                  ? 'spin 1s linear infinite'
                  : 'none',

                '@keyframes spin': {
                  from: {
                    transform: 'rotate(0deg)',
                  },

                  to: {
                    transform: 'rotate(360deg)',
                  },
                },
              }}
            />
          </IconButton>
        </Tooltip>
      </>
    ),

    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
      },
    },

    onDownload: () => {
      const esc = (val) =>
        `"${String(val ?? '').replace(/"/g, '""')}"`;

      const header = [
        'Job Number',
        'Task Number',
        'Client',
        'Project Manager',
        'City',
        'Task Scope',
        'Cost Item',
        'Group Number',
        'Seq Number',
        'Planned Date',
        'Assigned Members',
        'Document Link',
        'Estimated Hours',
        'Description',
      ]
        .map(esc)
        .join(',');

      const body = rawSchedules
        .map((item) => {
          const plannedDate = item.planned_date
            ? new Date(
              `${item.planned_date.split('T')[0]}T00:00:00`
            ).toLocaleDateString(
              'en-US',
              {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }
            )
            : '';

          return [
            item.job_id?.number_str || '',
            item.task?.number_str || '',
            item.client_id?.company_name || '',

            item.project_managers
              ?.map(
                (m) =>
                  `${m.first_name} ${m.last_name}`
              )
              .join(', ') || '',

            item.job_id?.locations?.[0]?.city ||
            '',

            item.task_scope_id?.name || '',

            Array.isArray(item.cost_item)
              ? item.cost_item.join(', ')
              : item.cost_item || '',

            item.group_number > 0
              ? item.group_number
              : '',

            item.sequence_number > 0
              ? item.sequence_number
              : '',

            plannedDate,

            item.assigned_members
              ?.map(
                (m) =>
                  `${m.first_name} ${m.last_name}`
              )
              .join(', ') || '',

            item.document_link || '',
            item.estimated_hours || '',
            item.description || '',
          ]
            .map(esc)
            .join(',');
        })
        .join('\r\n');

      return `${header}\r\n${body}\r\n`;
    },

    setRowProps: (
      row,
      dataIndex,
      rowIndex
    ) => ({
      style: {
        backgroundColor:
          rowIndex % 2 === 0
            ? 'rgba(101, 200, 208, 0.08)'
            : 'white',
      },
    }),

    setTableProps: () => ({
      padding: 'normal',
      border:
        '1px solid rgba(101, 200, 208, 0.25)',
      size: 'small',
    }),

    onChangeRowsPerPage: (
      numberOfRows
    ) => {
      setRowsPerPage(numberOfRows);
    },

    onSearchChange: (searchQuery) => {
      setSearchEnable(searchQuery);

      if (
        searchQuery !== null &&
        searchQuery.length > 2
      ) {
        if (
          Object.keys(sortEnable).length !== 0
        ) {
          const {
            sortField,
            sortOrder,
          } = sortEnable;

          getUserdata({
            sortField,
            sortOrder,
            searchQuery,
            manageId: manageId,
          });
        } else {
          getUserdata({
            searchQuery,
            manageId: manageId,
          });
        }

        setLoading(true);
      }

      if (searchQuery === null) {
        if (
          Object.keys(sortEnable).length !== 0
        ) {
          const {
            sortField,
            sortOrder,
          } = sortEnable.sortField;

          getUserdata({
            sortField,
            sortOrder,
            manageId: manageId,
          });
        } else {
          getUserdata({
            manageId: manageId,
          });
        }

        setLoading(true);
      }
    },

    rowsPerPage: rowsPerPage,

    serverSide: true,

    onTableChange: (
      action,
      tableState
    ) => {
      const {
        name,
        direction,
      } = tableState.sortOrder;

      const sortField = name;
      const sortOrder = direction;

      let searchQuery = searchEnable;
      let page_no = tableState.page;

      if (action === 'sort') {
        setSortEnable({
          sortField,
          sortOrder,
        });

        if (
          sortField === 'job_number' ||
          sortField === 'task_number'
        ) {
          const getValue =
            sortField === 'job_number'
              ? (item) =>
                item.job_id?.number_str ?? ''
              : (item) =>
                item.task?.number_str ?? '';

          setRawSchedules((prev) =>
            [...prev].sort((a, b) =>
              sortOrder === 'asc'
                ? getValue(a).localeCompare(
                  getValue(b)
                )
                : getValue(b).localeCompare(
                  getValue(a)
                )
            )
          );
        } else if (searchEnable) {
          getUserdata({
            sortField,
            sortOrder,
            searchQuery,
            page_no,
            manageId: manageId,
          });

          setLoading(true);
        } else {
          getUserdata({
            sortField,
            sortOrder,
            page_no,
            manageId: manageId,
          });

          setLoading(true);
        }
      }

      setPage(tableState.page);

      if (action === 'changePage') {
        if (searchEnable) {
          getUserdata({
            sortField,
            sortOrder,
            searchQuery,
            page_no,
            manageId: manageId,
          });
        } else {
          getUserdata({
            sortField,
            sortOrder,
            page_no,
            manageId: manageId,
          });
        }

        setLoading(true);
      }
    },

    onFilterChipClose: () => {
      setManageId('manager');
    },

    onFilterChange: (
      val,
      row,
      reset
    ) => {
      if (row[6].length === 0) {
        setManageId('manager');
      }

      if (reset === 'reset') {
        setManageId('manager');
      }
    },
  };

  const handleRefresh = async () => {
    await getUserdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: page ?? 0,
      manageId,
      plannedDate: selectedPlannedDate,
      groupNumber: selectedGroupNumber,
    });
  };

  const fetchAllSchedulesForAssign =
    async () => {
      try {
        const { data } =
          await authAxios.get(
            `${PRIVATE_ROUTE?.GET_SCHEDULE}?page=1&per_page=10000`
          );

        const schedules = (
          data?.data ?? []
        ).filter(
          (item) =>
            !item.is_deleted &&
            (!item.status ||
              item.status === 'open' ||
              item.status === 'assigned')
        );

        setAllSchedulesForAssign(
          schedules
        );

        return schedules;
      } catch (error) {
        console.error(
          'Error fetching all schedules:',
          error
        );

        return [];
      }
    };

  const managerdata = async () => {
    try {
      const response =
        await authAxios.get(
          `${PRIVATE_ROUTE?.GET_MANAGER}`
        );

      const filterEmployRole =
        response?.data?.data;

      setFilterManagerdata(
        filterEmployRole
      );
    } catch (error) {
      console.error(
        'Error fetching employee data:',
        error
      );
    }
  };

  const handleViewSchedules = async (
    schedule
  ) => {
    if (!schedule?._id) {
      console.error(
        'Schedule ID is missing:',
        schedule
      );

      return;
    }

    try {
      setScheduleLoading(true);

      const draftResponse =
        await authAxios.get(
          PRIVATE_ROUTE.GET_TODO_DRAFTS_FOR_SCHEDULE,
          {
            params: {
              job_id:
                schedule.job_id?.number_str,
              task_id:
                schedule.task?._id,
              schedule_id:
                schedule._id,
              linkedOnly: 'all',
            },
          }
        );

      const drafts =
        draftResponse?.data?.data || [];

      setScheduleModalData(drafts);
      setSelectedSchedule(schedule);
      setOpenViewToDoDraftModal(true);
    } catch (err) {
      console.error(
        'Error fetching Todo Draft:',
        err
      );

      setScheduleModalData([]);
    } finally {
      setScheduleLoading(false);
    }
  };

  const fetchValidCostItems = async () => {
    try {
      const { data } =
        await authAxios.get(
          `${PRIVATE_ROUTE?.GET_LABOUR_COST_ITEMS}`
        );

      setValidCostItems(
        data?.data ?? []
      );
    } catch (error) {
      console.error(
        'Error fetching labour cost items:',
        error
      );
    }
  };

  /*
   * ============================================================
   * EXISTING RAW SCHEDULE -> TABLE DATA MAPPING
   * ============================================================
   */
  useEffect(() => {
    setUsers(
      rawSchedules.map((item) => {
        const project_managers_name =
          (item.project_managers ?? []).map(
            (pmdetails) =>
              pmdetails.first_name +
              ' ' +
              pmdetails.last_name
          );

        const costItems = Array.isArray(
          item.cost_item
        )
          ? item.cost_item
          : item.cost_item
            ? [item.cost_item]
            : [];

        const validCostItemsForColor =
          costItems.filter((c) =>
            validCostItems.includes(c)
          );

        const scheduleColor =
          getScheduleColor(
            item.estimated_hours,
            validCostItemsForColor
          );

        return {
          _id: item._id,

          name: item.name,

          task_number: item.task ? (
            <Link
              to={`/task/view/${item.task._id}`}
            >
              <b>{item.task.number_str}</b>
            </Link>
          ) : (
            ''
          ),

          job_number: item.job_id ? (
            <Link
              to={`/job/view/${item.job_id._id}`}
              style={{
                textDecoration: 'none',
              }}
            >
              <Box
                sx={{
                  display: 'inline-block',
                  background:
                    scheduleColor,
                  color: '#fff',
                  borderRadius: '4px',
                  px: 0.75,
                  py: 0.25,
                  fontSize: '0.7rem',
                  fontWeight: 700,
                  whiteSpace:
                    'nowrap',
                }}
              >
                {
                  item.job_id
                    .number_str
                }
              </Box>
            </Link>
          ) : (
            ''
          ),

          client_number:
            item.client_id ? (
              <Link
                to={`/client/view/${item.client_id._id}`}
              >
                <b>
                  {
                    item.client_id
                      .company_name
                  }
                </b>
              </Link>
            ) : (
              ''
            ),

          city:
            item.job_id?.locations?.[0]
              ?.city ?? '',

          task_scope:
            item.task_scope_id?.name ??
            '',

          cost_item: costItems.map(
            (costItem, index) => (
              <p key={index}>
                {costItem}
              </p>
            )
          ),

          group_number:
            item.group_number > 0
              ? item.group_number
              : '',

          seq_number:
            item.sequence_number > 0
              ? item.sequence_number
              : '',

          planned_date:
            item.planned_date
              ? new Date(
                `${item.planned_date.split('T')[0]}T00:00:00`
              ).toLocaleDateString(
                'en-US',
                {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }
              )
              : '',

          manager:
            project_managers_name.join(
              ', '
            ),

          assigned_members:
            item.assigned_members.length
              ? item.assigned_members
                .map(
                  (emp) =>
                    `${emp.first_name} ${emp.last_name}`
                )
                .join(', ')
              : '',

          document_link:
            item.document_link ? (
              <Tooltip
                title={
                  item.document_link
                }
              >
                <IconButton
                  onClick={() => {
                    const url =
                      /^https?:\/\//i.test(
                        item.document_link
                      )
                        ? item.document_link
                        : `https://${item.document_link}`;

                    window.open(
                      url,
                      '_blank',
                      'noopener,noreferrer'
                    );
                  }}
                >
                  <LinkTwoToneIcon />
                </IconButton>
              </Tooltip>
            ) : (
              ''
            ),

          description:
            item.description || '',

          estimated_hours:
            item.estimated_hours,

          comments: (
            <IconButton
              onClick={() => {
                setSelectedSchedule(item);
                setCommentModal(true);
              }}
            >
              <CommentIcon />
            </IconButton>
          ),

          active:
            item.status === 'completed'
              ? null
              : (
                <Box
                  sx={{
                    display: 'flex',
                    gap: 0.75,
                    justifyContent:
                      'center',
                    flexWrap: 'wrap',
                  }}
                >
                  <Button
                    size="small"
                    type="submit"
                    variant={
                      item.assigned_members
                        .length
                        ? 'outlined'
                        : 'contained'
                    }
                    onClick={async () => {
                      await fetchAllSchedulesForAssign();

                      setSelectedSchedule(
                        item
                      );

                      setUserModal(true);
                    }}
                    sx={
                      item.assigned_members
                        .length
                        ? {
                          borderColor:
                            '#3DADB5',
                          color:
                            '#3DADB5',
                          fontWeight: 600,
                          fontSize:
                            '0.72rem',
                          textTransform:
                            'none',
                          borderRadius:
                            '20px',
                          px: 2,

                          '&:hover':
                          {
                            backgroundColor:
                              '#E0F6F8',
                            borderColor:
                              '#2E9DA6',
                          },
                        }
                        : {
                          backgroundColor:
                            '#65C8D0',
                          color: '#fff',
                          fontWeight: 600,
                          fontSize:
                            '0.72rem',
                          textTransform:
                            'none',
                          borderRadius:
                            '20px',
                          px: 2,
                          boxShadow:
                            'none',

                          '&:hover':
                          {
                            backgroundColor:
                              '#3DADB5',
                            boxShadow:
                              'none',
                          },
                        }
                    }
                  >
                    {item.assigned_members
                      .length
                      ? 'Reassign'
                      : 'Assign'}
                  </Button>

                  {item.assigned_members
                    .length > 0 && (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() =>
                          setUnassignTarget(
                            item
                          )
                        }
                        sx={{
                          borderColor:
                            '#e57373',
                          color: '#e57373',
                          fontWeight: 600,
                          fontSize:
                            '0.72rem',
                          textTransform:
                            'none',
                          borderRadius:
                            '20px',
                          px: 2,

                          '&:hover':
                          {
                            backgroundColor:
                              '#ffeaea',
                            borderColor:
                              '#c62828',
                          },
                        }}
                      >
                        Unassign
                      </Button>
                    )}
                </Box>
              ),
        };
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawSchedules, validCostItems]);

  const getUserdata = async (
    query = {}
  ) => {
    try {
      setLoading(true);

      let sort_params;

      let page_cout =
        query.page_no ?? 0;

      let planned_date =
        query.plannedDate !== undefined
          ? query.plannedDate
          : selectedPlannedDate || '';

      let group_number =
        query.groupNumber !== undefined
          ? query.groupNumber
          : selectedGroupNumber || '';

      let search_query =
        query.searchQuery
          ? encodeURIComponent(
            query.searchQuery
          )
          : '';

      let sortField =
        query.sortField ??
        sortEnable.sortField;

      let sortOrder =
        query.sortOrder ??
        sortEnable.sortOrder;

      let ProjectManger = '';

      if (
        query.manageId &&
        query.manageId !==
        'All_Manager'
      ) {
        ProjectManger =
          query.manageId;
      }

      if (typeof query !== 'string') {
        sort_params =
          `&sortField=${sortField}` +
          `&sortOrder=${sortOrder}` +
          `&search=${search_query}` +
          `&user_id=${ProjectManger}`;

        if (planned_date) {
          sort_params +=
            `&plannedDate=${planned_date}`;
        }

        if (group_number) {
          sort_params +=
            `&groupNumber=${group_number}`;
        }
      } else {
        sort_params =
          `&search=${query}`;
      }

      const [
        scheduleRes,
        employeeRes,
      ] = await Promise.all([
        authAxios.get(
          `${PRIVATE_ROUTE?.GET_SCHEDULE}?page=${page_cout + 1
          }&per_page=${rowsPerPage}${sort_params}`
        ),

        authAxios.get(
          `${PRIVATE_ROUTE?.GET_USER}?page=1&per_page=1000&search=`
        ),
      ]);

      const employeeData =
        employeeRes.data?.data || [];

      const employees =
        employeeData.map(
          (employee) => ({
            id: `${employee._id}`,
            first_name:
              employee.first_name,
            last_name:
              employee.last_name,
            role: employee.role,
          })
        );

      setEmployees(employees);

      const scheduleData =
        scheduleRes.data;
              
      const sorted = (
        scheduleData?.data ?? []
      ).filter((item) => {
        if (item.is_deleted) return false;
        console.log('item.status: ', item.status);
        if (isAdmin) {
          return (
            ['open', 'completed', 'assigned'].includes(item.status) &&
            Number(item.task?.is_completed) === 0
          );
        }

        // Existing behavior for non-admin users
        return (
          !item.status ||
          item.status === 'open' ||
          item.status === 'assigned'
        );
      });

      setRawSchedules(sorted);

      await fetchDwrAvailability(sorted);

      setCount(
        scheduleData.total || 0
      );
    } catch (err) {
      console.error(
        'Schedule fetch/render error:',
        err
      );
    } finally {
      setLoading(false);
    }
  };

  function handleChangeManager(e) {
    setLoading(true);

    getUserdata({
      sortField:
        sortEnable.sortField,
      sortOrder:
        sortEnable.sortOrder,
      searchQuery: searchEnable,
      manageId: e.target.value,
    });

    setManageId(
      e.target.value
    );
  }

  function handleDateSort() {
    if (
      selectedPlannedDate !== null ||
      selectedGroupNumber !== ''
    ) {
      setPage(0);
      setLoading(true);

      getUserdata({
        sortField:
          sortEnable.sortField,
        sortOrder:
          sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: 0,
        manageId,
        plannedDate:
          selectedPlannedDate,
        groupNumber:
          selectedGroupNumber,
      });
    }
  }

  function handleClearDateSort() {
    if (
      manageId !== 'All_Manager'
    ) {
      setIsValid(true);
      setManageId(
        'All_Manager'
      );
    } else if (
      selectedPlannedDate !== null ||
      selectedGroupNumber !== ''
    ) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }

    setSelectedPlannedDate(null);
    setSelectedGroupNumber('');
    setManageId(
      'All_Manager'
    );
  }

  const handleUnassign = async (
    schedule
  ) => {
    try {
      setLoading(true);

      let linkedDraft = null;

      try {
        const draftResponse =
          await authAxios.get(
            PRIVATE_ROUTE.GET_TODO_DRAFTS_FOR_SCHEDULE,
            {
              params: {
                job_id:
                  schedule.job_id
                    .number_str,
                task_id:
                  schedule.task._id,
                schedule_id:
                  schedule._id,
                linkedOnly: 'all',
              },
            }
          );

        linkedDraft =
          draftResponse?.data
            ?.data?.[0] || null;
      } catch (err) {
        console.error(
          'Error fetching linked Todo Draft:',
          err
        );
      }

      const response =
        await authAxios.post(
          `${PRIVATE_ROUTE.EDIT_SCHEDULE}${schedule._id}`,
          {
            assigned_members: [],
            planned_date: null,
            group_number: null,
            sequence_number: null,
            status: 'open',
          }
        );

      if (
        response?.data?.statusCode !==
        200
      ) {
        setMessageDialog({
          open: true,
          severity: 'error',
          title: 'Error',
          message:
            response?.data
              ?.message ||
            'Failed to update schedule.',
          okText: 'OK',
        });

        return;
      }

      if (linkedDraft) {
        try {
          const response =
            await authAxios.post(
              `${PRIVATE_ROUTE.EDIT_TODO_DRAFT}${linkedDraft._id}`,
              {
                schedule_id: null,
                status: 'open',
                field_trip_date: null,
                urgency: '',
                assigned_members: [],
                skipUpdatedAtCheck: true,
              }
            );

          if (
            response.data.statusCode !==
            200
          ) {
            setMessageDialog({
              open: true,
              severity: 'error',
              title: 'Error',
              message: `Schedule was unassigned but failed to update the linked Todo Draft. Reason: ${response.data.message}`,
              okText: 'OK',
            });

            return;
          }
        } catch (err) {
          console.error(
            'Error updating Todo Draft:',
            err
          );

          setMessageDialog({
            open: true,
            severity: 'error',
            title: 'Error',
            message:
              'Schedule was unassigned but failed to update the linked Todo Draft.',
            okText: 'OK',
          });

          return;
        }
      }

      setMessageDialog({
        open: true,
        severity: 'success',
        title: 'Success',
        message: linkedDraft
          ? 'Schedule and linked Todo Draft have been unassigned successfully.'
          : 'Schedule has been unassigned successfully.',
        okText: 'OK',
      });

      await Promise.all([
        fetchAllSchedulesForAssign(),

        getUserdata({
          sortField:
            sortEnable.sortField,
          sortOrder:
            sortEnable.sortOrder,
          searchQuery:
            searchEnable,
          page_no: page,
          manageId,
        }),
      ]);
    } catch (error) {
      console.error(error);

      setMessageDialog({
        open: true,
        severity: 'error',
        title: 'Error',
        message:
          error?.response?.data
            ?.message ||
          'Failed to unassign schedule.',
        okText: 'OK',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUserAssign = async (
    id,
    data
  ) => {
    try {
      setLoading(true);

      const updateData =
        await authAxios.post(
          `${PRIVATE_ROUTE?.EDIT_SCHEDULE}${id}`,
          {
            ...data,
          }
        );

      if (
        updateData?.data
          ?.statusCode === 400
      ) {
        toast.error(
          updateData.data.message
        );

        return false;
      }

      await fetchAllSchedulesForAssign();

      await getUserdata({
        sortField:
          sortEnable.sortField,
        sortOrder:
          sortEnable.sortOrder,
        searchQuery:
          searchEnable,

        page_no:
          selectedPlannedDate ||
            selectedGroupNumber
            ? 0
            : page ?? 0,

        manageId,

        plannedDate:
          selectedPlannedDate,

        groupNumber:
          selectedGroupNumber,
      });

      return true;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleDuplicateSchedule = async (item) => {
    try {
      setDuplicateLoading(true);

      const jobNumber = item.job_id?.number_str;
      const taskId = item.task?._id;
      const taskScopeId = item.task_scope_id?._id;

      if (!jobNumber || !taskId || !taskScopeId || !item.cost_item?.length) {
        toast.error('Unable to duplicate schedule. Required details are missing.');
        return;
      }

      const payload = {
        task_id: taskId,
        job_id: jobNumber,
        task_scope_id: taskScopeId,
        cost_item: Array.isArray(item.cost_item)
          ? item.cost_item.join(', ')
          : item.cost_item,
        ...(item.estimated_hours != null && {
          estimated_hours: Number(item.estimated_hours),
        }),
        ...(item.description && {
          description: item.description,
        }),
      };

      const res = await authAxios.post('schedule/create', payload);

      if (res?.data?.statusCode !== 200) {
        toast.error(res?.data?.message || 'Failed to duplicate schedule');
        return;
      }

      // The create endpoint should return the newly created schedule in data.
      const createdSchedule =
        res?.data?.data ??
        res?.data?.schedule ??
        res?.data?.result;

      if (!createdSchedule?._id) {
        toast.error('Schedule was created, but its details could not be retrieved.');
        await handleRefresh();
        return;
      }

      const duplicateTarget = {
        ...createdSchedule,
        job_number: item.job_id?.number_str || '',
        task_number: item.task?.number_str || '',
        task: item.task,
        job: item.job_id,
      };

      setDuplicateAssignTarget(duplicateTarget);

      toast.success('Schedule duplicated successfully');

      await handleRefresh();
    } catch (error) {
      console.error('Duplicate schedule error:', error);
      toast.error('Something went wrong while duplicating the schedule.');
    } finally {
      setDuplicateLoading(false);
    }
  };

  const handleDeleteSchedule = async (scheduleId) => {
    try {
      setDeleteLoading(true);

      const response = await authAxios.delete(
        `${PRIVATE_ROUTE.DELETE_SCHEDULE}${scheduleId}`
      );

      if (response.data.statusCode === 200) {
        toast.success('Schedule deleted successfully');
        setDeleteTarget(null);

        await getUserdata({
          sortField: sortEnable.sortField,
          sortOrder: sortEnable.sortOrder,
          searchQuery: searchEnable,
          page_no: page ?? 0,
          manageId,
        });
      } else {
        toast.error(
          response.data.message || 'Unable to delete schedule'
        );
      }
    } catch (error) {
      console.error('Schedule deletion failed:', error);
      toast.error('Failed to delete schedule');
    } finally {
      setDeleteLoading(false);
    }
  };

  const CustomFilterList = (
    props
  ) => (
    <TableFilterList
      {...props}
      ItemComponent={CustomChip}
    />
  );

  const CustomChip = ({
    label,
    onDelete,
  }) => (
    <Chip
      label={label}
      onDelete={onDelete}
      sx={{
        marginBottom: '10px',
      }}
    />
  );

  CustomChip.propTypes = {
    label: PropTypes.string.isRequired,
    onDelete:
      PropTypes.func.isRequired,
  };

  useEffect(() => {
    managerdata('');
    fetchValidCostItems();
    fetchAllSchedulesForAssign();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      rowsPerPage * page <
      count
    ) {
      getUserdata({
        sortField:
          sortEnable.sortField,
        sortOrder:
          sortEnable.sortOrder,
        searchQuery:
          searchEnable,
        page_no: page,
        manageId,
      });
    } else {
      getUserdata({
        sortField:
          sortEnable.sortField,
        sortOrder:
          sortEnable.sortOrder,
        searchQuery:
          searchEnable,
        manageId,
      });
    }

    setLoading(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage]);

  useEffect(() => {
    const prevStatus =
      prevUserModalRef.current;

    if (isValid) {
      getUserdata({
        sortField:
          sortEnable.sortField,
        sortOrder:
          sortEnable.sortOrder,
        searchQuery:
          searchEnable,
        page_no: page,
        manageId,
      });

      setIsValid(false);
      setLoading(true);
    }

    if (
      prevStatus === true &&
      openUserModal === false
    ) {
      getUserdata({
        sortField:
          sortEnable.sortField,
        sortOrder:
          sortEnable.sortOrder,
        searchQuery:
          searchEnable,
        page_no: page,
        manageId,
      });

      setIsValid(false);
      setLoading(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid, openUserModal]);

  return (
    <>
      {openUserModal && (
        <AssignUserModel
          opentStatus={
            openUserModal
          }
          setUserModal={
            setUserModal
          }
          employees={employees.filter(
            (emp) =>
              emp.role ===
              'employee' ||
              emp.role ===
              'manager'
          )}
          schedule={
            selectedSchedule
          }
          handleUserAssign={
            handleUserAssign
          }
          allSchedules={
            allSchedulesForAssign
          }
          onRefresh={
            handleRefresh
          }
        />
      )}

      <NewScheduleModal
        open={openNewScheduleModal}
        onClose={() => {
          setOpenNewScheduleModal(false);
        }}
        onSuccess={() => {
          getUserdata({
            sortField: sortEnable.sortField,
            sortOrder: sortEnable.sortOrder,
            searchQuery: searchEnable,
            page_no: page,
            manageId,
          });
          setLoading(true);
        }}
      />
      <LinkedDwrModal
        open={openDwrModal}
        loading={dwrModalLoading}
        dwrData={dwrModalData}
        schedule={selectedDwrSchedule}
        onClose={() => {
          setOpenDwrModal(false);
          setSelectedDwrSchedule(null);
          setDwrModalData([]);
        }}
      />
      <ViewToDoDraftModal
        open={
          openViewToDoDraftModal
        }
        drafts={
          scheduleModalData
        }
        loading={
          scheduleLoading
        }
        jobNumber={
          selectedSchedule
            ?.job_id?.number_str
        }
        taskNumber={
          selectedSchedule
            ?.task?.number_str
        }
        onClose={() => {
          setOpenViewToDoDraftModal(
            false
          );

          setScheduleModalData(
            []
          );

          setSelectedSchedule(
            null
          );
        }}
      />

      {todoDraftData.schedule && (
        <TodoDraftUpdateModal
          open={
            todoDraftUpdateModal
          }
          onClose={async () => {
            setTodoDraftUpdateModal(
              false
            );

            await getUserdata({
              sortField:
                sortEnable.sortField,
              sortOrder:
                sortEnable.sortOrder,
              searchQuery:
                searchEnable,
              page_no: page,
              manageId,
            });
          }}
          schedule={
            todoDraftData.schedule
          }
          initialFieldTripDate={
            todoDraftData.fieldTripDate
          }
          initialDescription={
            todoDraftData.description
          }
          status={
            todoDraftData.status
          }
          onSubmit={async () => {
            setTodoDraftUpdateModal(
              false
            );

            setMessageDialog({
              open: true,
              severity: 'success',
              title: 'Success',
              message:
                'Schedule and Todo Draft saved successfully.',
              okText: 'OK',
              cancelText: null,
              onConfirm: null,
            });

            await getUserdata({
              sortField:
                sortEnable.sortField,
              sortOrder:
                sortEnable.sortOrder,
              searchQuery:
                searchEnable,
              page_no: page,
              manageId,
            });
          }}
        />
      )}

      <MessageDialog
        open={
          messageDialog.open
        }
        severity={
          messageDialog.severity
        }
        title={
          messageDialog.title
        }
        message={
          messageDialog.message
        }
        okText={
          messageDialog.okText
        }
        cancelText={
          messageDialog.cancelText
        }
        onClose={() =>
          setMessageDialog(
            (prev) => ({
              ...prev,
              open: false,
            })
          )
        }
        onConfirm={async () => {
          setMessageDialog(
            (prev) => ({
              ...prev,
              open: false,
            })
          );

          if (
            messageDialog.onConfirm
          ) {
            await messageDialog.onConfirm();
          }
        }}
      />

      {openCommentModal && (
        <CommentsModal
          opentStatus={
            openCommentModal
          }
          setCommentModal={
            setCommentModal
          }
          selectedSchedule={
            selectedSchedule
          }
          user={state.user}
        />
      )}

      <Modal
        open={
          openDescriptionModal
        }
        onClose={() =>
          setDescriptionModal(
            false
          )
        }
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform:
              'translate(-50%, -50%)',
            width: {
              xs: '90vw',
              sm: 480,
            },
            bgcolor:
              'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              background:
                'linear-gradient(135deg, #65C8D0 0%, #3DADB5 100%)',
              px: 3,
              py: 2,
              display: 'flex',
              alignItems:
                'center',
              justifyContent:
                'space-between',
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: '#fff',
                fontWeight: 700,
              }}
            >
              Description
            </Typography>

            <IconButton
              size="small"
              onClick={() =>
                setDescriptionModal(
                  false
                )
              }
              sx={{
                color: '#fff',
              }}
            >
              ✕
            </IconButton>
          </Box>

          <Box
            sx={{
              px: 3,
              py: 2.5,
            }}
          >
            <Typography
              sx={{
                whiteSpace:
                  'pre-wrap',
                wordBreak:
                  'break-word',
                color: '#2a2a2a',
              }}
            >
              {selectedDescription}
            </Typography>
          </Box>
        </Box>
      </Modal>

      <Dialog
        open={Boolean(
          unassignTarget
        )}
        onClose={() =>
          setUnassignTarget(null)
        }
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
          },
        }}
      >
        <Box
          sx={{
            background:
              'linear-gradient(135deg, #e57373 0%, #c62828 100%)',
            px: 2.5,
            py: 1.5,
            display: 'flex',
            alignItems:
              'center',
            justifyContent:
              'space-between',
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontWeight: 700,
              fontSize:
                '0.95rem',
            }}
          >
            Confirm Unassign
          </Typography>

          <IconButton
            size="small"
            onClick={() =>
              setUnassignTarget(
                null
              )
            }
            sx={{
              color: '#fff',
            }}
          >
            ✕
          </IconButton>
        </Box>

        <Box
          sx={{
            px: 2.5,
            py: 2,
          }}
        >
          <Typography
            sx={{
              fontSize:
                '0.85rem',
              color: '#333',
            }}
          >
            Are you sure you want
            to unassign this
            schedule? The associated
            Todo Draft will also be
            reset.
          </Typography>
        </Box>

        <Box
          sx={{
            px: 2.5,
            py: 1.5,
            borderTop:
              '1px solid #f0f0f0',
            display: 'flex',
            justifyContent:
              'flex-end',
            gap: 1.5,
          }}
        >
          <Button
            variant="outlined"
            onClick={() =>
              setUnassignTarget(
                null
              )
            }
            sx={{
              borderColor:
                '#bdbdbd',
              color: '#555',

              '&:hover': {
                borderColor:
                  '#9e9e9e',
                backgroundColor:
                  '#f5f5f5',
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={async () => {
              setUnassignTarget(
                null
              );

              await handleUnassign(
                unassignTarget
              );
            }}
            sx={{
              backgroundColor:
                '#e57373',

              '&:hover': {
                backgroundColor:
                  '#c62828',
              },

              fontWeight: 700,
              px: 3,
            }}
          >
            Unassign
          </Button>
        </Box>
      </Dialog>
      <Dialog

        open={!!duplicateAssignTarget}
        onClose={() => setDuplicateAssignTarget(null)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700 }}>
          Assign Duplicate Schedule?
        </DialogTitle>

        <DialogContent>
          <Typography sx={{ fontSize: '0.9rem', color: '#555' }}>
            The schedule has been duplicated successfully.
            Would you like to assign it now?
          </Typography>
          <Typography sx={{ fontSize: '0.80rem', color: '#333', mt: 1 }}>
            Job: <strong>{duplicateAssignTarget?.job_id}</strong>
            {' | '}
            Task: <strong>{duplicateAssignTarget?.task_number}</strong>
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setDuplicateAssignTarget(null)}
            sx={{
              borderColor: '#3DADB5',
              color: '#3DADB5',
            }}
          >
            No
          </Button>

          <Button
            variant="contained"
            onClick={async () => {
              const scheduleToAssign = duplicateAssignTarget;

              setDuplicateAssignTarget(null);

              const schedules = await fetchAllSchedulesForAssign();

              const latestSchedule =
                schedules.find(
                  (schedule) =>
                    String(schedule._id) === String(scheduleToAssign._id)
                ) || scheduleToAssign;

              setSelectedSchedule(latestSchedule);
              setUserModal(true);
            }}
            sx={{
              backgroundColor: '#3DADB5',
              '&:hover': { backgroundColor: '#65C8D0' },
            }}
          >
            Yes, Assign
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(deleteTarget)}
        onClose={() => {
          if (!deleteLoading) setDeleteTarget(null);
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
          },
        }}
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #e57373 0%, #c62828 100%)',
            px: 2.5,
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontWeight: 700,
              fontSize: '0.95rem',
            }}
          >
            Confirm Delete
          </Typography>

          <IconButton
            size="small"
            disabled={deleteLoading}
            onClick={() => setDeleteTarget(null)}
            sx={{ color: '#fff' }}
          >
            ✕
          </IconButton>
        </Box>

        <Box sx={{ px: 2.5, py: 2 }}>
          <Typography sx={{ fontSize: '0.85rem', color: '#333' }}>
            Are you sure you want to delete this schedule?
          </Typography>
          <Typography sx={{ fontSize: '0.85rem', color: '#333' }}>
            {deleteTarget?.job_id?.number_str && (
              <>
                {' '}Job: <strong>{deleteTarget.job_id.number_str}</strong>
              </>
            )}

            {deleteTarget?.task?.number_str && (
              <>
                {' '}| Task: <strong>{deleteTarget.task.number_str}</strong>
              </>
            )}
          </Typography>
        </Box>

        <Box
          sx={{
            px: 2.5,
            py: 1.5,
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1.5,
          }}
        >
          <Button
            variant="outlined"
            disabled={deleteLoading}
            onClick={() => setDeleteTarget(null)}
            sx={{
              borderColor: '#bdbdbd',
              color: '#555',
              '&:hover': {
                borderColor: '#9e9e9e',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            disabled={deleteLoading}
            onClick={() => handleDeleteSchedule(deleteTarget._id)}
            sx={{
              backgroundColor: '#e57373',
              '&:hover': {
                backgroundColor: '#c62828',
              },
              fontWeight: 700,
              px: 3,
            }}
          >
            {deleteLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </Box>
      </Dialog >
      <Grid
        sx={{
          px: 3,
          pt: 3,
          pb: 0,
          overflow: 'hidden',
        }}
      >
        {/* Page Header */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={2.5}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: '#2a2a2a',
            }}
          >
            Job Scheduling
          </Typography>

          <Button
            variant="contained"
            onClick={() => {
              setOpenNewScheduleModal(true);
            }}
            startIcon={<CalendarMonthIcon />}
          >
            New Schedule
          </Button>
        </Stack>

        {/* Filter Card */}
        <Grid
          container
          xs={12}
          spacing={2}
          sx={{
            py: 2,
            alignItems: 'top',
          }}
        >
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              paddingTop:
                '0px !important',
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select Manager
              </InputLabel>

              <Select
                label="Select Manager"
                fullWidth
                value={manageId}
                onChange={(e) =>
                  handleChangeManager(
                    e
                  )
                }
              >
                <MenuItem value="All_Manager">
                  All
                </MenuItem>

                {filterManagerdata.map(
                  (items) => (
                    <MenuItem
                      key={items._id}
                      value={items._id}
                    >
                      {`${items.first_name}  ${items.last_name}`}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            md={2}
          >
            <LocalizationProvider
              dateAdapter={
                AdapterDayjs
              }
            >
              <DatePicker
                inputFormat="YYYY-MM-DD"
                value={
                  selectedPlannedDate
                    ? dayjs(
                      selectedPlannedDate
                    )
                    : null
                }
                onChange={(value) => {
                  const formattedDate =
                    value
                      ? dayjs(
                        value
                      ).format(
                        'YYYY-MM-DD'
                      )
                      : null;

                  setSelectedPlannedDate(
                    formattedDate
                  );
                }}
                label="Planned Date"
                renderInput={(
                  props
                ) => (
                  <TextField
                    {...props}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid
            item
            xs={12}
            md={2}
            sx={{
              paddingTop:
                '0px !important',
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="group-number-label">
                Group Number
              </InputLabel>

              <Select
                labelId="group-number-label"
                label="Group Number"
                value={
                  selectedGroupNumber
                }
                onChange={(e) =>
                  setSelectedGroupNumber(
                    e.target.value
                  )
                }
              >
                <MenuItem value="">
                  All
                </MenuItem>

                {Array.from(
                  {
                    length: 10,
                  },
                  (_, i) => i + 1
                ).map((n) => (
                  <MenuItem
                    key={n}
                    value={n}
                  >
                    {n}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            md="auto"
            sx={{
              paddingTop:
                '5px !important',
            }}
          >
            <Button
              size="large"
              type="submit"
              variant="contained"
              onClick={
                handleDateSort
              }
              disabled={
                selectedPlannedDate ===
                null &&
                selectedGroupNumber ===
                ''
              }
            >
              Submit
            </Button>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            sx={{
              paddingTop:
                '5px !important',
            }}
          >
            <Button
              size="large"
              type="submit"
              variant="outlined"
              onClick={() =>
                handleClearDateSort()
              }
              disabled={
                manageId ===
                'All_Manager' &&
                selectedPlannedDate ===
                null &&
                selectedGroupNumber ===
                ''
              }
            >
              Reset
            </Button>
          </Grid>
        </Grid>

        {/* Estimated Hours Legend */}
        <ColorLegend />

        {/* Data Table */}
        {loading && (
          <Backdrop
            sx={{
              color: '#fff',
              zIndex: (theme) =>
                theme.zIndex.drawer +
                1,
            }}
            open={loading}
          >
            <CircularProgress
              sx={{
                color: '#65C8D0',
              }}
            />
          </Backdrop>
        )}

        <Box
          sx={{
            backgroundColor:
              '#fff',
            border:
              '1px solid rgba(101, 200, 208, 0.25)',
            overflow: 'hidden',
            boxShadow:
              '0 1px 4px rgba(101,200,208,0.1)',
          }}
        >
          <MUIDataTable
            options={options}
            columns={columns}
            data={users}
            components={{
              TableFilterList:
                CustomFilterList,
            }}
          />
        </Box>
      </Grid>
    </>
  );
}